var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"w-full"},[_c('Input',_vm._g(_vm._b({attrs:{"min":_vm.min,"step":_vm.step,"type":"number"},scopedSlots:_vm._u([{key:"right",fn:function(){return [_c('div',{staticClass:"px-3 text-sm text-gray-500"},[_vm._v("\n        "+_vm._s(_vm.unit('weight'))+"\n      ")])]},proxy:true}])},'Input',_vm.$attrs,false),_vm.$listeners))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }